import { ProcurementType } from 'models/procurement.model';
import { createContext, Dispatch, SetStateAction, useContext } from 'react';

export type ExecutiveContextType = {
  setProcurementToUpdate: Dispatch<SetStateAction<ProcurementType>>;
  procurementToUpdate: ProcurementType;
};

export const ExecutiveContext = createContext({} as ExecutiveContextType);
const useExecutiveContext = () => {
  const context = useContext(ExecutiveContext);
  return context;
};

export default useExecutiveContext;
